
import { Vue, Options, Prop } from "vue-property-decorator";
@Options({
  name: "ui-message-success",
})
export default class UiMessageSuccess extends Vue {
  @Prop({ type: String, default: "" }) text: string;
}
